import axiosInstance from './axiosConfig';
import { createCancelToken } from './axiosUtils';

const ApiKeyAPI = {
  getAll: function ({ org_id, offset, limit, search, folder_id }) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/integrations`,
      params: { search, offset, limit, folder_id },
      cancelToken: cancelTokenObject[this.getAll.name].requestCancellation().token,
    });
  },
  getById: function (org_id, api_key_id) {
    return axiosInstance.request({
      method: 'GET',
      url: `/organizations/${org_id}/integrations/${api_key_id}`,
    });
  },
  create: function ({ org_id, name, role, folder_ids }) {
    return axiosInstance.request({
      method: 'POST',
      url: `/organizations/${org_id}/integrations`,
      data: { name, role, folder_ids },
    });
  },
  update: function ({ org_id, api_key_id, name, role, folder_ids }) {
    return axiosInstance.request({
      method: 'PUT',
      url: `/organizations/${org_id}/integrations/${api_key_id}`,
      data: { name, role, folder_ids },
    });
  },
  delete: function (org_id, api_key_id) {
    return axiosInstance.request({
      method: 'DELETE',
      url: `/organizations/${org_id}/integrations/${api_key_id}`,
    });
  },
};

const cancelTokenObject = createCancelToken(ApiKeyAPI);
export default ApiKeyAPI;
